import { sortBy } from 'lodash';

import { firestore, FieldValue } from './initFirebase';

import { PlayerSummary } from "./Common";

import Styles from './Room.module.scss';

import * as Game from './copied/Game';

const PlayerEntry = (
	{ entry, uid, ownerId, promptStatusChange } :
	{
		entry: [string, any],
		uid: string,
		ownerId: string,
		promptStatusChange: () => void
	}
) => {
	const roomUserId = entry[0];
	const roomUser = entry[1];

	return <div key={roomUserId}
		className={roomUserId === uid ? Styles.userMe : Styles.userOther}>
		{roomUserId === ownerId
		&& <div className={Styles.roomOwnerBadge}>Room creator</div>}
		
		{roomUser.health == null // TODO fix this dirty hack
		? <b>{roomUser.nickname}</b>
		: <PlayerSummary user={roomUser} />
		}

		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
		}}>{roomUser.status}</div>

		<div className={Styles.userExtra} onClick={
			roomUserId != uid ? undefined : promptStatusChange
		}>
			{roomUserId == uid
			? (roomUser.status ? <>{roomUser.status}<br />(click to change)</> : "Click to set your status. Tell others your plans or how to message you privately (e.g. Discord id).")
			: (roomUser.status ? roomUser.status : "This player hasn't set status yet")
			}
		</div>
	</div>;
}

function RoomUsers(
	{ users, actionLauncher, uid, ownerId, roomStateType } :
	{
		users: { [key: string]: Game.User },
		actionLauncher: (action: Game.Action, confirmationMessage?: string) => () => Promise<void>,
		uid: string,
		ownerId: string,
		roomStateType: string,
	}
) {
	function promptStatusChange() {
		const nextStatus = window.prompt('Would you like to change your status?', users[uid].status);
		if (nextStatus == null)
			return;

		actionLauncher({
			type: Game.ActionType.SetStatus,
			actorId: '',
			status: nextStatus,
		})();
	}

	const completeList = sortBy(
		Object.entries(users),
		(roomUser: any) => roomUser[1].nickname
	) as [string, any][];


	const playerEntryToNode = (e: [string, Game.User]) =>
		<PlayerEntry key={e[0]} entry={e} uid={uid} ownerId={ownerId} promptStatusChange={promptStatusChange} />;


	return <div className={Styles.roomUsers}>
		{roomStateType === 'preparation'
		? <>
			<h2 style={{ paddingLeft: '15px' }}>Players</h2>
			{completeList.map(playerEntryToNode)}
		</>
		: (() => {
			const aliveList = completeList.filter(e => e[1].health > 0);
			const deadList = completeList.filter(e => e[1].health <= 0);

			return <>
				<h2 style={{ paddingLeft: '15px' }}>
					{roomStateType === 'finished'
					? 'Winner'
					: 'Alive'}
				</h2>
				{aliveList.map(playerEntryToNode)}
				
				{deadList.length > 0
				&& <>
					<h2 style={{ paddingLeft: '15px' }}>
						{roomStateType === 'finished'
						? 'Fallen'
						: 'Dead - The Jury'}
					</h2>
					{deadList.map(playerEntryToNode)}
				</>}
			</>
		})()
	}
			

	</div>;
}

export default RoomUsers;

			// (roomUserDoc: any) => {
			// const roomUserId = roomUserDoc[0];
			// const roomUser = roomUserDoc[1];

			// 	//<b>UID</b>: {roomUserId.substr(0, 7)}... <br />
			// return <div key={roomUserId}
			// 	className={roomUserId === uid ? Styles.userMe : Styles.userOther}>
			// 	{roomUserId === ownerId
			// 	&& <div className={Styles.roomOwnerBadge}>Room creator</div>}
				
			// 	{roomUser.health == null // TODO fix this dirty hack
			// 	? <b>{roomUser.nickname}</b>
			// 	: <PlayerSummary user={roomUser} />
			// 	}

			// 	<div style={{
			// 		textOverflow: 'ellipsis',
			// 		whiteSpace: 'nowrap',
			// 		overflow: 'hidden',
			// 	}}>{roomUser.status}</div>

			// 	<div className={Styles.userExtra} onClick={
			// 		roomUserId != uid ? undefined : promptStatusChange
			// 	}>
			// 		{roomUserId == uid
			// 		? (roomUser.status ? <>{roomUser.status}<br />(click to change)</> : "Click to set your status. Tell others your plans or how to message you privately (e.g. Discord id).")
			// 		: (roomUser.status ? roomUser.status : "This player hasn't set status yet")
			// 		}
			// 	</div>
			// </div>;



				//  <>
				// 	<div>Health: {roomUser.health}</div>
				// 	<div>Action points: {roomUser.actionPoints}</div>
				// 	<div>Range: {roomUser.range}</div>
				// 	{roomUser.health > 0
				// 	? <div>Votes received: {roomUser.votesReceived}</div>
				// 	: <div>Votes available: {roomUser.votesAvailable}</div>}
				// </>
